import {FC, ReactElement} from "react";
import classNames from "classnames";

export interface ModalProps {
  title?: string;
  open: boolean;
  onClose: () => void;
  children?: ReactElement;
  className?: string;
}

export default function Modal(props: ModalProps): ReturnType<FC> {
  return (
    <div
      className={`modal  ${props.className} ${props.open ? "display-block" : "display-none"}`}
    >
      <div className="backdrop fixed left-0 top-0 w-full h-full bg-black bg-opacity-50" onClick={()=>props.onClose()}></div>
      <div className="modal-main rounded-md">
        <div className="modal-body min-w-full p-6">{props.children}</div>
      </div>
    </div>
  );
}
